var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v("财务导出")]),_c('div',{staticStyle:{"display":"inline-block"}},[_c('Date-picker',{staticStyle:{"width":"200px"},attrs:{"type":"month","placeholder":"选择月"},model:{value:(_vm.month),callback:function ($$v) {_vm.month=$$v},expression:"month"}})],1),_c('i-button',{on:{"click":_vm.downloadReport}},[_vm._v("下载")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }